import React from 'react'
import PropTypes from 'prop-types'
import styles from './style.module.scss'

import CustomLink from '@shared/components/customLink'
import { RightBracketArrow } from '../ctIcons'
function StatsCardTable({ data, cardtitle }) {
  return (
    <>
      {data?.length !== 0 &&
        <section className="widget">
          <div className={`font-semi items common-box p-0 ${styles.wtc2023}`}>
            <>
            <div className={`position-relative ${styles.borderRadius} ${styles.bgGrey}`}>
                <h3 className={`${styles.cardtitle}`}>{cardtitle}</h3>
              </div>
              <div className={`${styles.iccLinks}`}>
                {data?.map((series) => {
                  return (
                    <CustomLink key={series?.description} href={`${series?.url}`} prefetch={false}>
                      <a className="cs-item d-flex py-3 justify-content-between">
                        <span className="overflow-hidden text-nowrap d-flex">{series?.description}</span>
                        <div className={`${styles.iccContent}`}>
                          <RightBracketArrow/>
                        </div>
                      </a>
                    </CustomLink>
                  )
                })}
              </div>
            </>
          </div>
        </section>
      }
    </>
  )
}

StatsCardTable.propTypes = {
  data: PropTypes.object,
  cardtitle: PropTypes.string,
  urlStat: PropTypes.string
}

export default StatsCardTable
